export function optionKey(opt) {
  return String(opt.id ?? opt.name ?? '');
}

export function isCheckboxCustomization(c, groupKey) {
  const t = String(c?.type ?? '').toLowerCase();
  const ui = String(c?.uiType ?? '').toLowerCase();
  if (t === 'checkbox' || ui === 'checkbox') return true;
  if (c?.allowMultiple === true || c?.multiSelect === true) return true;
  const k = String(groupKey ?? '').toLowerCase();
  if (k === 'additional_customization' || k === 'additionalcustomization') return true;
  return false;
}

export function buildDefaultCustomizations(product) {
  if (!product) return {};
  const defaults = {};
  for (const [key, customization] of Object.entries(product?.customizations ?? {})) {
    const options = customization?.options ?? [];
    if (isCheckboxCustomization(customization, key)) {
      const withDefault = options.filter((opt) => opt.isDefault).map(optionKey).filter(Boolean);
      defaults[key] = withDefault.length ? withDefault : [];
    } else {
      const defaultOption = options.find((opt) => opt.isDefault) ?? options[0] ?? null;
      if (defaultOption) defaults[key] = optionKey(defaultOption);
    }
  }
  return defaults;
}

/** Secondary line under radio option title (price / recommended). */
export function customizationOptionSubtext(groupKey, opt) {
  if (groupKey === 'piece_cut_size') return null;
  const add = Number(opt.additionalPrice) || 0;
  if (opt.isDefault) {
    return add > 0 ? `Recommended · +₹${add}` : 'Recommended · +₹0';
  }
  return add > 0 ? `+₹${add}` : '+₹0';
}

/** Price suffix for checkbox / add-on options. */
export function customizationAddOnPriceLabel(opt) {
  const add = Number(opt?.additionalPrice) || 0;
  return add > 0 ? `+₹${add}` : '+₹0';
}

export function sectionLabel(displayName, groupKey) {
  return String(displayName || groupKey || '')
    .trim()
    .toUpperCase();
}
